// extracted by mini-css-extract-plugin
module.exports = {"button_container":"simulatneous-action-dialog_button_container__3HK05","title":"simulatneous-action-dialog_title__32MWq","content":"simulatneous-action-dialog_content__2Fkw_"};